/**
 * Workspace table component
 */

import React from 'react';
import type { Workspace, AccessEvoRegion } from '../types';
import { Badge } from './ui/badge';

interface WorkspaceTableProps {
  workspaces: Workspace[];
  onView: (tenantOrWorkspaceId: string) => void;
  isLoading?: boolean;
  startIndex?: number;
}

export function WorkspaceTable({ workspaces, onView, isLoading, startIndex = 0 }: WorkspaceTableProps) {
  if (isLoading) {
    return (
      <div className="animate-pulse">
        <div className="h-12 bg-gray-200 rounded mb-4"></div>
        <div className="space-y-3">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="h-16 bg-gray-200 rounded"></div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <table className="data-table workspace-table">
      <thead>
        <tr>
          <th>#</th>
          <th>Tenant ID</th>
          <th>Access Evo Region</th>
          <th>Application Subscription ID</th>
          <th>Organization ID</th>
          <th>Salesforce ID</th>
          <th>Insert Timestamp</th>
          <th>Updated Timestamp</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {workspaces.map((workspace, index) => (
          <tr key={`${(workspace as any).id ?? workspace.tenantId}-${workspace.applicationSubscriptionId}-${index}`}>
            <td>{startIndex + index + 1}</td>
            <td>{(workspace as any).id ?? workspace.tenantId}</td>
            <td>
              <Badge variant={workspace.accessEvoRegion}>
                {workspace.accessEvoRegion}
              </Badge>
            </td>
            <td>{workspace.applicationSubscriptionId}</td>
            <td>{workspace.organisationId || '-'}</td>
            <td>{workspace.salesforceId || '-'}</td>
            <td>{workspace.insertTimestamp}</td>
            <td>{workspace.updatedTimestamp}</td>
            <td>
              <div className="row-actions">
                <button
                  className="access-btn access-secondary"
                  onClick={() => onView((workspace as any).id ?? workspace.tenantId)}
                  title="View workspace"
                >
                  View
                </button>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
